"use strict";
// packages/shared/src/projection-windows.ts
//
// Single source of truth for per-pillar projection windows.
// AFI-F1 calibration: update minHours/maxHours/displayLabel here;
// G1 (methodology page), G2 (onboarding step), and G3 (dashboard hints)
// all read from this module — one change propagates everywhere.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECTION_DISCLAIMER = exports.PROJECTION_WINDOWS = void 0;
exports.PROJECTION_WINDOWS = {
    seo: {
        pillar: 'seo',
        pillarLabel: 'SEO',
        pillarFullName: 'Search Engine Optimization',
        minHours: 24,
        maxHours: 48,
        displayLabel: '24–48 hours',
        detailedDescription: 'Search engines re-crawl your pages within hours of changes appearing in your sitemap or RSS feeds. SEO sub-score updates reflect newly indexed content quickly.',
        methodologyRef: 'methodology-overview/v0.1#timing',
    },
    aeo: {
        pillar: 'aeo',
        pillarLabel: 'AEO',
        pillarFullName: 'AI Engine Optimization',
        minHours: 168, // 7 days
        maxHours: 168,
        displayLabel: '~7 days',
        detailedDescription: 'AI answer engines refresh their underlying corpus and prompt-data on roughly-weekly cycles. Structured content and FAQ deployment shows up in answer rates within this window.',
        methodologyRef: 'methodology-overview/v0.1#timing',
    },
    geo: {
        pillar: 'geo',
        pillarLabel: 'GEO',
        pillarFullName: 'Generative Engine Optimization',
        minHours: 336, // 14 days
        maxHours: 720, // 30 days
        displayLabel: '14–30 days',
        detailedDescription: 'Entity authority signals — citations, schema completeness, off-domain mentions — accumulate slowly through the broader web ecosystem. GEO sub-score reflects the cumulative effect of authority-building over weeks.',
        methodologyRef: 'methodology-overview/v0.1#timing',
    },
};
/**
 * Calibration disclaimer shown alongside every projection display.
 * Informational, not exculpatory.
 */
exports.PROJECTION_DISCLAIMER = "These are typical ranges. Your domain's actual movement depends on your starting position and competitive landscape.";
//# sourceMappingURL=projection-windows.js.map